// Components
import VAppBarNavIcon from '../VAppBar/VAppBarNavIcon';
// Utilities
import { deprecate } from '../../util/console';
/* @vue/component */
export default VAppBarNavIcon.extend({
    name: 'v-toolbar-side-icon',
    render: function render(h, context) {
        deprecate('<v-toolbar-side-icon>', '<v-app-bar-nav-icon>', this);
        return VAppBarNavIcon.options.render.call(this, h, context);
    }
});
//# sourceMappingURL=VToolbarSideIcon.js.map